import {Component, OnDestroy, OnInit} from '@angular/core';
import {Apollo, gql} from 'apollo-angular';
import {Subject, Subscription} from 'rxjs';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CountryISO} from 'ngx-intl-tel-input';
import {phoneNumberValidator} from '../../shared/utils';
import {SendQuestionnaireInput} from '../../shared/graphql/globalTypes';
import {catchError, exhaustMap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {ErrorService} from '../../shared/services/error.service';

const NEW_QUESTIONNAIRE = gql`
  mutation NewQuestionnaire($input: SendQuestionnaireInput!) {
    sendQuestionnaire(input: $input) {
      url
      errors
    }
  }
`;

@Component({
  selector: 'app-new-questionnaire',
  templateUrl: './new-questionnaire.component.html',
  styleUrls: ['./new-questionnaire.component.scss'],
})
export class NewQuestionnaireComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  newQuestionnaireForm = new FormGroup({
    phoneNumber: new FormControl(null, [Validators.required, phoneNumberValidator.bind(this)]),
    firstName: new FormControl(null, Validators.required),
    lastName: new FormControl(null, Validators.required),
  });
  CountryISO = CountryISO;
  formSubmitted = false;
  submit$ = new Subject<SendQuestionnaireInput>();

  constructor(
    private apollo: Apollo,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private errorHandler: ErrorService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.submit$
        .pipe(
          exhaustMap(input => {
            return this.apollo
              .mutate({
                mutation: NEW_QUESTIONNAIRE,
                variables: {
                  input,
                },
                update: cache =>
                  cache.evict({id: 'ROOT_QUERY', fieldName: 'outstandingQuestionnaires'}),
              })
              .pipe(catchError(error => this.errorHandler.handleApollo(error)));
          }),
        )
        .subscribe(output => {
          this.toastr.success(this.translate.instant('VITALITY_SCAN_SENT'), '', {
            timeOut: 2000,
          });
          this.router.navigate(['dashboard', 'questionnaires']);
        }),
    );
  }

  onSubmit(): void {
    this.formSubmitted = true;

    if (this.newQuestionnaireForm.valid) {
      const formValue: SendQuestionnaireInput = {
        phoneNumber: this.newQuestionnaireForm.controls.phoneNumber.value.e164Number,
        firstName: this.newQuestionnaireForm.controls.firstName.value,
        lastName: this.newQuestionnaireForm.controls.lastName.value,
      };

      this.submit$.next(formValue);
      this.formSubmitted = false;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
